import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import ConnectorPanel from "./ConnectorPanel";

// Microsoft 365 (Microsoft Graph).
//
// This is NOT "Sign in with Microsoft". That one is configured by the platform
// administrator for the whole install and appears on the sign-in page; it requests only
// openid/profile/email.
//
// This connector needs its own app registration in the customer's tenant, with Graph
// APPLICATION permissions. Reusing the SSO registration would add "read every user and
// device in your directory" to the consent prompt that every person sees when they sign
// in — which is why the catalogue keeps the two as separate cards.

const FIELDS = [
  {
    key: "directory_id",
    label: "Directory (tenant) ID",
    required: true,
    help: "Entra admin centre → Overview → Tenant ID.",
  },
  {
    key: "client_id",
    label: "Application (client) ID",
    required: true,
    help: "From the app registration you created for Pipsqueak.",
  },
  {
    key: "client_secret",
    label: "Client secret",
    secret: true,
    required: true,
    help: "Certificates & secrets → New client secret. Copy the Value, not the Secret ID.",
  },
];

const HELP = {
  summary: "Pull users, devices, licences and service health from Microsoft Graph.",
  customerNoun: "Microsoft tenant",
  steps: [
    "In the Entra admin centre, go to App registrations → New registration. No redirect URI is needed — this connector never signs anyone in.",
    "Under API permissions, add the Microsoft Graph APPLICATION permissions listed above, then Grant admin consent.",
    "Under Certificates & secrets, create a client secret and copy its Value.",
    "Paste the three values here, press Connect, then Test connection.",
  ],
};

const Microsoft365Panel = ({ isAdmin }) => {
  const [permissions, setPermissions] = useState([]);

  // Read from the server rather than hardcoded here, so the list an admin is told to
  // consent to cannot drift from the endpoints the connector actually calls.
  useEffect(() => {
    api.get("s2/api/integrations/microsoft-365/permissions")
      .then((d) => setPermissions(d?.permissions || []))
      .catch(() => setPermissions([]));
  }, []);

  return (
    <ConnectorPanel
      isAdmin={isAdmin}
      provider="microsoft-365"
      title="Microsoft 365"
      fields={FIELDS}
      help={HELP}
      permissions={permissions}
    />
  );
};

export default Microsoft365Panel;
